import { MainGateway } from './main-gateway.interface';

export const initMainAPI = (apiSlice: any, gateway: MainGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['PP'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getLatestPlanDePrincipeData: builder.query({
          query: gateway.getLatestPlanDePrincipeData,
          providesTags: ['PP'],
        }),
        getAllPlanDePrincipeData: builder.query({
          query: gateway.getAllPlanDePrincipeData,
          providesTags: ['PP'],
        }),
        postPlanDePrincipeData: builder.mutation({
          query: gateway.saveNewPlanDePrincipeData,
          invalidatesTags: ['PP'],
        }),
        postErrorMessage: builder.mutation({
          query: gateway.postErrorMessage,
        }),
        getCalculatorResponse: builder.query({
          query: gateway.getCalculatorResponse,
        }),
        getCitySuggestion: builder.query({
          query: gateway.getCitySuggestion,
        }),
      }),
      overrideExisting: false,
    });
};

export interface MainSliceType {
  useGetLatestPlanDePrincipeDataQuery: Function;
  useGetAllPlanDePrincipeDataQuery: Function;
  usePostPlanDePrincipeDataMutation: Function;
  usePostErrorMessageMutation: Function;
  useGetCalculatorResponseQuery: Function;
  useLazyGetCalculatorResponseQuery: Function;
  useGetCitySuggestionQuery: Function;
  useLazyGetCitySuggestionQuery: Function;
}
